export default {
  getAccountData: '/courier/api/financial/find/cash/account',
  getIncomeData: '/courier/api/v2/bigdataIncome'
}
